<template>
    <div>
        <modal class="new-modal-default" :name="modal_name" transition="nice-modal-fade" :delay="100" :width="780"
            :height="475" :left="280" :pivot-y="0.5" :adaptive="true" :scrollable="true">
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <!-- Header Section -->
                <div class="v-modal-header modal-height">
                    <span class="v-modal-dialog-title v-modal-title fw-400 py-3 ml-auto mr-auto"
                        style="color: #fff !important;letter-spacing:1px;">Create Sales Forecast</span>
                    <button type="button" class="pointer" style="background-color: #00448b !important;outline:none;"
                        aria-label="Close" @click="hideCreateSalesForecast()">
                        <span aria-hidden="true">
                            <i class="icon icon-close" style="color:white;margin:10px -10px 0 0;"></i>
                        </span>
                    </button>
                </div>
                <!-- Body Section -->
                <div class="v-modal-body" style="overflow:auto;">
                    <div class="col-md-6 col-sm-12 mt-4 mt-3">
                        <p class="input-title">Create Sales Forecast based on</p>
                        <div class="d-flex align-items-center">
                            <div class="d-flex justify-content-between align-items-center mr-4">
                                <div class="form-check form-check-inline mb-1 ">
                                    <label class="form-check-label check-label-dc">
                                        <input class="form-check-input" type="radio" @change="resetData('fiscal_year')" v-model="sales_forecast_based_on"
                                            value="fiscal_year" name="fiscal_year" />
                                        <span class="radio-icon color-icon"></span>
                                    </label>
                                </div>
                                <span class="text-radiobtn fs-14 fw-600 mr-2" :class="{'radio-activebtn':sales_forecast_based_on == 'fiscal_year'}">Fiscal Year</span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="form-check form-check-inline mb-1 ">
                                    <label class="form-check-label check-label-dc">
                                        <input class="form-check-input" type="radio" @change="resetData('manual')" v-model="sales_forecast_based_on"
                                            value="manual" name="manual"/>
                                        <span class="radio-icon color-icon"></span>
                                    </label>
                                </div>
                                <span class="text-radiobtn fs-14 fw-600 mr-2" :class="{'radio-activebtn':sales_forecast_based_on == 'manual'}">Manual Selection</span>
                            </div>
                        </div>
                    </div>
                    <div class="container-fluid">
                        <div class="row spacing">
                            <div class="col-lg-4 col-md-6 col-sm-12 mt-3">
                                <div class="w-100" v-if="sales_forecast_based_on == 'manual'">
                                    <span class="input-title">Forecast Period<sup class="fs-14 ml-02 text-danger">*</sup></span>
                                    <div class="d-flex align-content-center mt-3">
                                        <multiselect autocomplete="off" v-validate="'required'"
                                            class="diginew-multiselect text-capitalize new-align-multi no-default-icon down-arrow"
                                            :searchable="true" name="forecast_period" v-model="forecast_period"
                                            :options="forecast_period_options" placeholder="Select Forecast Period">
                                            <template slot="option" slot-scope="{ option }">
                                                <span class="text-capitalize">{{ option.replace('_',' ') }}</span>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <div class="text-right pr-10">
                                        <span class="float-left text-danger mb-3"
                                            v-show="errors.has('forecast_period')">Forecast Period is Required</span>
                                    </div>
                                </div>
                                <div class="w-100" v-else-if="sales_forecast_based_on == 'fiscal_year'">
                                    <span class="input-title">Fiscal Year<sup class="fs-14 ml-02 text-danger">*</sup></span>
                                    <div class="d-flex align-content-center mt-3">
                                        <multiselect ref="multiselectRef" autocomplete="off" v-validate="'required'"
                                            class="diginew-multiselect new-align-multi no-default-icon down-arrow"
                                            :searchable="true" name="fiscal_year_period" v-model="fiscal_year"
                                            :options="fiscal_year_period" placeholder="Select Fiscal Year">
                                        </multiselect>
                                    </div>
                                    <div class="text-right pr-10">
                                        <span class="float-left text-danger mb-3"
                                            v-show="errors.has('fiscal_year_period')">Fiscal Year is Required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12 mt-3">
                                <div class="w-100">
                                    <span class="input-title">Target based on</span>
                                    <div class="d-flex align-content-center mt-3">
                                        <multiselect ref="multiselectRef" autocomplete="off"
                                            class="diginew-multiselect text-capitalize new-align-multi no-default-icon down-arrow"
                                            :searchable="true" name="amount" v-model="target_based_on" :options="amount_options" placeholder="Enter Target Based On">
                                            <template slot="option" slot-scope="{ option }">
                                                <span class="text-capitalize">{{ option.replace('_',' ') }}</span>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        <!--quarterly-->
                            <div class="col-lg-4 col-md-6 col-sm-12 mt-3" v-if="sales_forecast_based_on == 'manual' && (forecast_period == 'month' || forecast_period == 'quarterly' || forecast_period == 'half_yearly')">
                                <div class="w-100">
                                    <span class="input-title">Year<sup class="fs-14 ml-02 text-danger">*</sup></span>
                                    <div class="d-flex align-content-center mt-3">
                                        <multiselect ref="multiselectRef" autocomplete="off" v-validate="'required'"
                                            class="diginew-multiselect new-align-multi no-default-icon down-arrow"
                                            :searchable="true" name="year" v-model="year"
                                            :options="years" placeholder="Select Forecast Period">
                                        </multiselect>
                                    </div>
                                    <div class="text-right pr-10">
                                        <span class="float-left text-danger mb-3"
                                            v-show="errors.has('year')">Year is Required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12 mt-3" v-if="sales_forecast_based_on == 'manual' && (forecast_period == 'month' || forecast_period == 'quarterly' || forecast_period == 'half_yearly')">
                                <div class="w-100" v-if="forecast_period == 'month'">
                                    <span class="input-title">Month<sup class="fs-14 ml-02 text-danger">*</sup></span>
                                    <div class="d-flex align-content-center mt-3">
                                        <multiselect ref="multiselectRef" autocomplete="off" v-validate="'required'"
                                            class="diginew-multiselect text-capitalize new-align-multi no-default-icon down-arrow"
                                            :searchable="true" name="month" v-model="month" :options="months" placeholder="Select Month">
                                            <template slot="option" slot-scope="{ option }">
                                                <span class="text-capitalize">{{ option.replace('_',' ') }}</span>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <div class="text-right pr-10">
                                        <span class="float-left text-danger mb-3"
                                            v-show="errors.has('month')">Month is Required</span>
                                    </div>
                                </div>
                                <div class="w-100" v-if="forecast_period == 'quarterly'">
                                    <span class="input-title">Quarterly<sup class="fs-14 ml-02 text-danger">*</sup></span>
                                    <div class="d-flex align-content-center mt-3">
                                        <multiselect ref="multiselectRef" autocomplete="off" v-validate="'required'"
                                            class="diginew-multiselect text-capitalize new-align-multi no-default-icon down-arrow"
                                            :searchable="true" name="quarter" v-model="quarter" :options="quarterly" placeholder="Select Quarterly">
                                            <template slot="option" slot-scope="{ option }">
                                                <span class="text-capitalize">{{ option.replace('_',' ') }}</span>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <div class="text-right pr-10">
                                        <span class="float-left text-danger mb-3"
                                            v-show="errors.has('quarter')">Quarterly is Required</span>
                                    </div>
                                </div>
                                <div class="w-100" v-if="forecast_period == 'half_yearly'">
                                    <span class="input-title">Half Yearly<sup class="fs-14 ml-02 text-danger">*</sup></span>
                                    <div class="d-flex align-content-center mt-3">
                                        <multiselect ref="multiselectRef" autocomplete="off" v-validate="'required'"
                                            class="diginew-multiselect text-capitalize new-align-multi no-default-icon down-arrow"
                                            :searchable="true" name="half_year" v-model="half_year" :options="half_yearly" placeholder="Select Quarterly">
                                            <template slot="option" slot-scope="{ option }">
                                                <span class="text-capitalize">{{ option.replace('_',' ') }}</span>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <div class="text-right pr-10">
                                        <span class="float-left text-danger mb-3"
                                            v-show="errors.has('half_year')">Half Year is Required</span>
                                    </div>
                                </div>
                            </div>
                        <!--date-->
                        <!-- <div class="row spacing" v-if="forecast_period == 'date'">
                            <div class="col-lg-6 col-md-6 col-sm-12 mt-1">
                                <div class="w-100">
                                    <span class="input-title">Start Date<sup class="fs-14 ml-02 text-danger">*</sup></span>
                                    <div class="d-flex align-items-center mt-3">
                                        <date-picker v-model="start_date" v-validate="'required'" name="start_date" class="meetinfdatetime calendar-edit-per calendar-edit-per-margin deal-date mx-left mr-1"  value-type="format" type="date" format="YYYY-MM-DD" lang="en" :clearable="false"  confirm confirm-text="APPLY"></date-picker>
                                    </div>
                                    <div class="text-right pr-10">
                                        <span class="float-left text-danger mb-3" v-show="errors.has('start_date')">Start Date is Required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 mt-1">
                                <div class="w-100">
                                    <span class="input-title">End Date<sup class="fs-14 ml-02 text-danger">*</sup></span>
                                    <div class="d-flex align-items-center mt-3">
                                    <date-picker v-model="end_date" v-validate="'required'" name="end_date" class="meetinfdatetime calendar-edit-per calendar-edit-per-margin deal-date mx-left mr-1"  value-type="format" type="date" format="YYYY-MM-DD" lang="en" :clearable="false"  confirm confirm-text="APPLY"></date-picker>
                                    </div>
                                    <div class="text-right pr-10">
                                        <span class="float-left text-danger mb-3" v-show="errors.has('end_date')">End Date is Required</span>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <!--product-->
                            <div class="col-lg-4 col-md-6 col-sm-12 mt-3">
                                <div class="w-100">
                                    <span class="input-title">Product<sup class="fs-14 ml-02 text-danger">*</sup></span>
                                    <div class="d-flex align-content-center mt-3"> 
                                        <multiselect :max="10" v-validate="'required'"
                                            class="diginew-multiselect text-capitalize new-align-multi no-default-icon down-arrow"
                                            placeholder="Select Product" name="products"
                                            label="name" open-direction="bottom"
                                            v-model="product" @open="resetData('name')"
                                            :options="products_options" track-by="name"
                                            :multiple="false" :searchable="true" :internal-search="true"
                                            :clear-on-select="false" :close-on-select="true" :options-limit="3000"
                                            :max-height="200" :show-no-results="true" :hide-selected="false"
                                            :blockKeys="['Delete']" :limit="1" :limit-text="limitProducts" :loading="products_loading" @search-change="searchProuctName"
                                        >
                                            <template slot="option" slot-scope="props" class="d-flex">
                                                {{ props.option.name }}
                                            </template>
                                            <template slot="afterList">
                                                <div v-observe-visibility="reachedEndOfProductName" />
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">Products Not Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                        <!-- <multiselect ref="multiselectRef" autocomplete="off" label="name" v-validate="'required'" @search-change="searchProducts" :loading="products_loading"
                                            class="diginew-multiselect text-capitalize new-align-multi no-default-icon down-arrow"
                                            :searchable="true" name="product" v-model="product" :options="products_options"
                                            placeholder="Select Products">
                                            <template slot="afterList">
                                                <div v-observe-visibility="reachedEndOfProducts" />
                                            </template>
                                            <template slot="option" slot-scope="{ option }">
                                                <span class="text-capitalize">{{ option.name.replace('_',' ') }}</span>
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center font-weight-bold">Products Not Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Data Found</div>
                                            </template>
                                        </multiselect> -->
                                    </div>
                                    <div class="text-right pr-10">
                                        <span class="float-left text-danger mb-3" v-show="errors.has('product')">Product is Required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12 mt-3">
                                <div class="w-100">
                                    <span class="input-title">Territory/Region</span>
                                    <div class="d-flex align-content-center mt-3">
                                        <multiselect ref="multiselectRef" autocomplete="off" @search-change="searchTerritories" :loading="territories_loading"
                                            class="diginew-multiselect new-align-multi no-default-icon down-arrow text-capitalize"
                                            :searchable="true" name="name" label="name" v-model="territory" :options="territories" placeholder="Select Territory/Region">
                                            <template slot="afterList">
                                                <div v-observe-visibility="reachedEndOfTerritories" />
                                            </template>
                                            <template slot="option" slot-scope="{ option }">
                                                <span class="text-capitalize">{{ option.name.replace('_',' ') }}</span>
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center font-weight-bold">Territories Not Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Data Found</div>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12 mt-3">
                                <div class="w-100">
                                    <span class="input-title">Country</span>
                                    <div class="d-flex align-content-center mt-3">
                                        <multiselect ref="multiselectRef" autocomplete="off" v-model="location.country"
                                            class="diginew-multiselect new-align-multi no-default-icon down-arrow"
                                            :searchable="true" name="country" :options="countries" placeholder="Select Country">
                                        </multiselect>
                                        <span class="pointer ml-3" @click="getLocation">
                                            <img src="/static/images/images-new-theme/icons/GPS 2.svg" style="height: 40px;" />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="disableButtonAndDisplayLoader == false" class="v-modal-footer m-auto p-4">
                    <button class="btn btn-des-small ml-2 mr-2 mt-3 cancel-hover"
                        style="color: #E82828; border: 1px solid #E82828; background: #fff; width: 170px;"
                        @click="hideCreateSalesForecast()">Cancel</button>
                    <button class="btn btn-des-small ml-2 mr-2 mt-3"
                        style="color: #fff; background: #008a63; border: 1px solid #008a63; width: 170px;"
                         :disabled="check_response" @click="saveSalesForecast()">Save</button>
                    <button class="btn btn-des-small ml-2 mr-2 mt-3"
                        style="color: #fff; background: #00448b; border: 1px solid #00448b; width: 170px;" :disabled="check_response" @click="saveAssign()">Save &
                        Assign Target</button>
                </div>
                <div v-else class="v-modal-footer m-auto p-4">
                    <button class="btn btn-des-small ml-2 mr-2 mt-3"
                        style="color: #E82828; border: 1px solid transparent !important; background: #fff; width: 170px;" disabled>Cancel</button>
                    <button class="btn btn-des-small ml-2 mr-2 mt-3"
                        style="color: #fff; background: #008a63; border: 1px solid transparent !important;position: relative; width: 170px;" disabled>Save
                        <hollow-dots-spinner v-if="saveButtonLoader" style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                    </button>
                    <button class="btn btn-des-small ml-2 mr-2 mt-3"
                        style="color: #fff; background: #00448b; border: 1px solid transparent !important;position: relative; width: 170px;" disabled>Save & Assign Target
                        <hollow-dots-spinner v-if="assignButtonLoader" style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                    </button>
                </div>
            </div>
        </modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>

<script>
    import countries from "../json/countries.json";
    import deals from "../mixins/deals";
    import salesforecast from "../mixins/salesforecast";
    import settings from "../mixins/settings";
    import productList from "../mixins/productList";
    import {EventBus} from '../eventBus/nav-bar-event';
    import { SweetModal } from 'sweet-modal-vue';
    import axios from "axios";
    import { debounce } from 'lodash'
    import { HollowDotsSpinner } from "epic-spinners";
    export default {
        props: ["modal_name","selected_id"],
        data() {
            return {
                saveButtonLoader: false,
                assignButtonLoader: false,
                disableButtonAndDisplayLoader: false,
                success_msg: 'Sales Forecast Created Succesfully',
                warning_msg: '',
                sales_forecast_based_on: "fiscal_year",
                fiscal_year: "",
                fiscal_year_period: [
                    '2022-2023',
                    '2023-2024',
                    '2024-2025',
                    '2025-2026',
                    '2026-2027',
                    '2027-2028',
                    '2028-2029',
                    '2029-2030',
                    '2030-2031',
                    '2031-2032',
                    '2032-2033',
                    '2033-2034',
                    '2034-2035',
                    '2035-2036',
                    '2036-2037',
                    '2037-2038',
                    '2038-2039',
                    '2039-2040',
                    '2040-2041',
                    '2041-2042',
                    '2042-2043',
                    '2043-2044',
                    '2044-2045'
                ],
                forecast_period: "",
                forecast_period_options: ['month', 'half_yearly','quarterly'],
                target_based_on: "",
                amount_options: ['amount','quantity','revenue'],
                location: {
                    street: '',
                    city: '',
                    township: '',
                    country: '',
                    zip_code: '',
                    latitude: '',
                    longitude: ''
                },
                countries: countries,
                show_settarget: false,
                //products lazy loading
                products_count: 0,
                products_loading:false,
                products_scrollable :false,
                products_visible: false,
                product: "",
                temp_products: [],
                products_options: [],
                search_key: '',
                //territories lazy loading
                territories_count: 0,
                territories_loading:false,
                territories_scrollable :false,
                territories_visible: false,
                territory: null,
                temp_territories: [],
                territories: [],
                quarter: null,
                half_year: null,
                year: null,
                years: ['2022','2023','2024'],
                month: null,
                months: ['january','february','march','april','may','june','july','august','september','october','november','december'],
                quarterly: ['q1','q2','q3','q4'],
                half_yearly: ['h1','h2'],
                half_year: null,
                start_date: null,
                end_date: null,
                check_response: false,
                selected_field:'',
            }
        },
        mixins:[deals,settings,salesforecast, productList],
        methods: {
            limitProducts(count){
                return `+${count} more`
            },
            resetData(type){
                this.selected_field = type
                this.products_options = [];
                this.products_count = 0;
            },
            async searchProuctNameDebouncer(search){
                this.products_loading = true
                this.products_count = 0
                let params = {
                    skip: this.skip,
                    limit: 10,
                    search_key: search,
                    sort_key: "name",
                    sort_value: 1,
                    category_ids:[],
                    sub_category_ids:[],
                    product_type_ids:[],
                    product_ids:[],
                    brand_ids:[],
                    outlet_ids:[],
                    status:[],  
                    visibility:"Manufacturing"
                }
                let response = await this.ProductsList(params)
                this.products_options = response.response.result
                
                this.products_count = this.products_options.length
                this.products_loading = false
            },
            async reachedEndOfProductName(reached){
                if(reached){
                    if(this.products_scrollable == false){
                        this.products_loading = true
                        let response = await this.ProductsList({
                            skip: this.products_count,
                            limit: 10,
                            search_key: '',
                            sort_key: "name",
                            sort_value: 1,
                            category_ids:[],
                            sub_category_ids:[],
                            product_type_ids:[],
                            product_ids:[],
                            brand_ids:[],
                            outlet_ids:[],
                            status:[],  
                            visibility:"Manufacturing"
                        } )
                        let temp_products_options = response.response.result.length;
                        if(response.response.filter_data.skip == this.products_count){
                            if(temp_products_options > 0){
                                let tempfiles = response.response.result
                                // tempfiles.forEach(el => {
                                //     if(el[this.selected_field] != '' && el.hasOwnProperty(this.selected_field)){
                                //         this.products_options.push(el)
                                //     }
                                // })
                                // let uniqueArray = this.products_options.filter((value, index_dd) => {
                                //     const _value = value[this.selected_field];
                                //     return index_dd === this.products_options.findIndex(obj => {
                                //         return obj[this.selected_field] === _value;
                                //     });
                                // });
                                this.products_options = tempfiles
                                this.products_count += response.response.result.length;
                                this.products_loading = false
                            } else {
                                this.products_scrollable = true
                                this.products_loading = false
                            }
                            this.products_scrollable = false
                        }
                    }
                }
            },
            resetData(obj){
                if(obj == 'fiscal_year'){
                    this.sales_forecast_based_on = 'fiscal_year';
                    this.quarter = null
                    this.half_year = null
                    this.forecast_period = ""
                }
                else if(obj == 'manual'){
                    this.sales_forecast_based_on = 'manual';
                    this.fiscal_year = ""
                }
            },
            hideCreateSalesForecast() {
                this.$modal.hide(this.modal_name)
                this.$emit("hideCreateSalesForecast")
            },
            //products lazy loading
            async searchProductsDebounce(search_key) {
                this.search_key = search_key
                this.products_loading = true
                try {
                    let params = {
                        skip: 0,
                        limit: 10,
                        search_key: this.search_key,
                        sort_value: 1,
                        sort_key: "name"
                    };
                    let response = await this.getProductsList(params)
                    this.products_options = response.response;
                    this.products_count = response.response.length;
                    this.products_loading = false
                }
                catch(error) {
                }
            },
            async reachedEndOfProducts(reached) {
                this.products_visible = reached
                if (reached) {
                    if (this.products_scrollable == false) {
                        this.products_loading = true
                        let response = await this.getProductsList({
                            skip: this.products_count,
                            limit: 10,
                            search_key: this.search_key,
                            sort_value: 1,
                            sort_key: "name"
                        })
                        this.temp_products = response.response.length;
                        if (response.skip == this.products_count) {
                            if (this.temp_products > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.products_options.push(el);
                                });
                                this.products_options = this.products_options.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.products_options.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.products_count += response.response.length;
                                this.products_loading = false
                            } else {
                                this.products_scrollable = true
                                this.products_loading = false
                            }
                        }
                        this.products_loading = false
                    }
                }
            },
            //territories lazy loading
            async searchTerritoriesDebounce(search_key) {
                this.territories_loading = true
                try {
                    let params = {
                        skip: 0,
                        limit: 10
                    };
                    let response = await this.getTerritoryList(params)
                    this.territories = response.response;
                    this.territories_count = response.response.length;
                    this.territories_loading = false
                }
                catch(error) {
                }
            },
            async reachedEndOfTerritories(reached) {
                this.territories_visible = reached
                if (reached) {
                    if (this.territories_scrollable == false) {
                        this.territories_loading = true
                        let response = await this.getTerritoryList({
                            skip: this.territories_count,
                            limit: 10
                        })
                        this.temp_territories = response.response.length;
                        if (response.skip == this.territories_count) {
                            if (this.temp_territories > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.territories.push(el);
                                });
                                this.territories = this.territories.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.territories.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.territories_count += response.response.length;
                                this.territories_loading = false
                            } else {
                                this.territories_scrollable = true
                                this.territories_loading = false
                            }
                        }
                        this.territories_loading = false
                    }
                }
            },
            locationLatLong(latitude, longitude) {
                axios.get(
                        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyCQSEwELtCrUrLSfsqU0wX7QAHbLVQzUrY`
                    )
                    .then(results => {
                        var i = 0
                        var street_name
                        var street_number
                        for (i = 0; i < results.data.results.length; i++) {
                            for (var j = 0; j < results.data.results[i].address_components.length; j++) {
                                for (var k = 0; k < results.data.results[i].address_components[j].types
                                    .length; k++) {
                                    if (results.data.results[i].address_components[j].types[k] == "postal_code") {
                                        this.location.zip_code = results.data.results[i].address_components[j]
                                            .short_name;
                                    }
                                    if (results.data.results[i].address_components[j].types[k] == 'route') {
                                        street_name = results.data.results[i].address_components[j].short_name;
                                    }
                                    if (results.data.results[i].address_components[j].types[k] == 'street_number') {
                                        street_number = results.data.results[i].address_components[j].short_name;
                                    }
                                }
                            }
                        }
                        this.location.street = street_number + ',' + ' ' + street_name
                        this.address.street1 = street_name
                        this.address.city = this.location.city
                        this.address.zip_code = this.location.zip_code
                        this.address.state = this.location.township
                        this.address.country = this.location.country
                        this.address.township = this.location.state
                        this.address.building_no = this.location.city.substr(0, 10);
                    })
            },
            getLocation() {
                if (navigator.geolocation) {
                    // timeout at 60000 milliseconds (60 seconds)
                    var options = {
                        enableHighAccuracy: false,
                        timeout: 30000, // milliseconds (30 seconds)
                        maximumAge: 600000
                    }; // milliseconds (10 minutes)
                    navigator.geolocation.getCurrentPosition(
                        this.showLocation,
                        this.errorHandler,
                        options
                    );
                } else {
                    alert("Sorry, browser does not support geolocation!");
                }
            },
            showLocation(position) {
                this.latitude = position.coords.latitude;
                this.longitude = position.coords.longitude;
                let latlongvalue = position.coords.latitude + "," + position.coords.longitude;
                let calllatlong = axios.create();
                delete calllatlong.defaults.headers.common['Authorization'];
                calllatlong.post("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + latlongvalue +
                        "&key=AIzaSyCQSEwELtCrUrLSfsqU0wX7QAHbLVQzUrY")
                    .then(response => {
                        let address = response.data.results[0].formatted_address.split(", ");
                        this.location.city = address[address.length - 3] || "";
                        this.location.country = address[address.length - 1];
                        let statezip = address[address.length - 2] ? address[address.length - 2].split(" ") : ["",
                            ""
                        ];
                        this.location.state = statezip[0].match(/^[a-zA-Z]+$/) ? statezip[0] : statezip[1].match(
                            /^[a-zA-Z]+$/) ? statezip[1] : "";
                        this.location.street = address[address.length - 4] || "";
                    })
                    .catch(e => {
                        // this.errors.push(e)
                    });
            },
            errorHandler(err) {
                if (err.code == 1) {
                    // alert("Error: Access is denied!");
                } else if (err.code == 2) {
                    // alert("Error: Position is unavailable!");
                }
            },
            setPlace(place) {
                let address = place.formatted_address.split(", ");
                this.location.city = address[address.length - 3] || "";
                this.location.country = address[address.length - 1];
                let statezip = address[address.length - 2] ? address[address.length - 2].split(" ") : ["", ""];
                this.location.state = statezip[0].match(/^[a-zA-Z]+$/) ? statezip[0] : statezip[1].match(
                    /^[a-zA-Z]+$/) ? statezip[1] : "";
                this.location.street = address[address.length - 4] || "";
            },
            saveSalesForecast() {
                let check_forecast_period = false
                if(this.sales_forecast_based_on == 'manual' && this.forecast_period == ''){
                    check_forecast_period = true
                }
                this.$validator.validateAll().then(async result => {
                    this.disableButtonAndDisplayLoader = true;
                    if(result == false){
                        this.disableButtonAndDisplayLoader = false;
                    }
                    this.saveButtonLoader = true;
                    if(!check_forecast_period){
                        this.disableButtonAndDisplayLoader = true;
                        if(this.forecast_period == 'quarterly'){
                            this.create_sales_forecast['quarter'] = this.quarter
                            this.create_sales_forecast['year'] = this.year
                        }
                        if(this.forecast_period == 'month'){
                            this.create_sales_forecast['month'] = this.month
                            this.create_sales_forecast['year'] = this.year
                        }
                        if(this.forecast_period == 'half_yearly'){
                            this.create_sales_forecast['half_year'] = this.half_year
                            this.create_sales_forecast['year'] = this.year
                        }
                        // if(this.forecast_period == 'date'){
                        //     this.create_sales_forecast['start_date'] = this.start_date
                        //     this.create_sales_forecast['end_date'] = this.end_date
                        // }
                        // if(this.sales_forecast_based_on == 'fiscal_year'){
                        //     this.create_sales_forecast['fiscal_year'] = this.fiscal_year
                        // }
                        // if(this.sales_forecast_based_on == 'manual'){
                        //     this.create_sales_forecast['forecast_period'] = this.forecast_period
                        // }
                        // this.check_response = true
                        try{
                            let response = await this.addSalesForeCast(this.create_sales_forecast)
                            this.check_response = false
                            this.$refs.success_modal.open();
                            setTimeout(() => {
                                this.disableButtonAndDisplayLoader = false;
                                this.saveButtonLoader = false;
                                this.$refs.success_modal.close();
                                this.$router.push("/salesForeCast/view_sales_forecast/"+response.id)
                            }, 3000);
                        } catch(error){
                            this.warning_msg = error
                            this.$refs.warning_modal.open();
                            setTimeout(() => {
                                this.disableButtonAndDisplayLoader = false;
                                this.saveButtonLoader = false;
                                this.$refs.warning_modal.close();
                            }, 3000);
                        }
                        this.disableButtonAndDisplayLoader = false;
                    }
                    else{
                        this.warning_msg = "Please provide Forecast Period"
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.disableButtonAndDisplayLoader = false;
                            this.saveButtonLoader = false;
                            this.$refs.warning_modal.close();
                        }, 2000);
                    }
                })
            },
            saveAssign() {
                let check_forecast_period = false
                if(this.sales_forecast_based_on == 'manual' && this.forecast_period == ''){
                    check_forecast_period = true
                }
                this.$validator.validateAll().then(async result => {
                    this.disableButtonAndDisplayLoader = true;
                    this.assignButtonLoader = true;
                    if(result == false){
                        this.disableButtonAndDisplayLoader = false;
                    }
                    if(!check_forecast_period){
                        if(this.forecast_period == 'quarterly'){
                            this.create_sales_forecast['quarter'] = this.quarter
                            this.create_sales_forecast['year'] = this.year
                        }
                        if(this.forecast_period == 'month'){
                            this.create_sales_forecast['month'] = this.month
                            this.create_sales_forecast['year'] = this.year
                        }
                        if(this.forecast_period == 'half_yearly'){
                            this.create_sales_forecast['half_year'] = this.half_year
                            this.create_sales_forecast['year'] = this.year
                        }
                        if(this.forecast_period == 'date'){
                            this.create_sales_forecast['start_date'] = this.start_date
                            this.create_sales_forecast['end_date'] = this.end_date
                        }
                        // if(this.sales_forecast_based_on == 'fiscal_year'){
                        //     this.create_sales_forecast['fiscal_year'] = this.fiscal_year
                        // }
                        // if(this.sales_forecast_based_on == 'manual'){
                        //     this.create_sales_forecast['forecast_period'] = this.forecast_period
                        // }
                        // this.check_response = true
                        try{
                            let response = await this.addSalesForeCast(this.create_sales_forecast)
                            this.check_response = false
                            this.$refs.success_modal.open();
                            setTimeout(() => {
                                this.disableButtonAndDisplayLoader = false;
                                this.assignButtonLoader = false;
                                this.$refs.success_modal.close();
                                this.show_settarget = true
                                EventBus.$emit("target", this.show_settarget)
                                EventBus.$emit("forecast_period", this.create_sales_forecast)
                                this.updatePathParams(this.$router, { id: response.id });
                                this.$modal.hide(this.modal_name)
                            }, 3000);
                        } catch(error){
                            this.warning_msg = error
                            this.$refs.warning_modal.open();
                            setTimeout(() => {
                                this.disableButtonAndDisplayLoader = false;
                                this.assignButtonLoader = false;
                                this.$refs.warning_modal.close();
                            }, 3000);
                        }
                        this.disableButtonAndDisplayLoader = false;
                    }
                    else{
                        this.warning_msg = "Please provide Forecast Period"
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.disableButtonAndDisplayLoader = false;
                            this.assignButtonLoader = false;
                            this.$refs.warning_modal.close();
                        }, 2000);
                    }
                })
            },
            updatePathParams($router, newParams) {
                // Retrieve current params
                const currentParams = $router.currentRoute.params;
                // Create new params object
                const mergedParams = { ...currentParams, newParams };
                $router.push({ params: {id: mergedParams.newParams.id} });
            }
        },
        computed:{
            searchProuctName(){
                return debounce(this.searchProuctNameDebouncer, 500)
            },
            create_sales_forecast(){
                return{
                    sales_forecast_based_on: this.sales_forecast_based_on,
                    target_based_on: this.target_based_on,
                    forecast_period: this.forecast_period,
                    fiscal_year: this.fiscal_year,
                    country: this.location.country,
                    territory_id: this.territory ? this.territory.id : "",
                    product_id: this.product == null ? "" : this.product._id,
                    product_name: this.product == null ? "" : this.product.name
                }
            }
        },
        components:{
            SweetModal,
            HollowDotsSpinner
        },
        created(){
            setTimeout(() => {
				this.$refs.multiselectRef.$refs.search.setAttribute("autocomplete", "off")
            }, 1000);
            this.searchProducts = debounce(this.searchProductsDebounce, 500)
            this.searchTerritories = debounce(this.searchTerritoriesDebounce, 500)
        }
    }
</script>
<style scoped>
    .modal-height {
        height: 40px !important;
    }

    .input-title {
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.39px;
        text-align: left;
        color: #00448b;
        font-size: 14px;
    }

    .spacing {
        padding: 5px;
    }

    .radiobtn {
        flex-wrap: wrap-reverse;
    }

    .text-radiobtn {
        color: rgba(103, 103, 103, 0.84);
    }

    .radio-activebtn {
        color: #00448b;
    }

    .color-icon:before{
        color:#0475f3 !important;
    }

    .new-modal-default.v--modal-overlay .v--modal-box{
        border-radius: 3px !important;
        /* border-bottom-right-radius: 3px !important; */
    }
    .cancel-hover:hover{
        background-color: #E82828 !important;
		color: #fff !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/SalesForeCast/CreateSalesforecast.vue